export function getFontCssUrl(
  mediaUrl: string,
  customerId: string,
  fontFamily: string,
): string {
  const normalized = fontFamily.trim();
  return `${mediaUrl}/fonts/${customerId}/css?family=${encodeURIComponent(normalized)}`;
}
